import React, { useEffect, useState } from "react";
import { projectsData } from "./Data";
import { projectsNav } from "./Data";
import WorkItems from "./WorkItems";

const Works = () => {
  const [selectedCategory, setSelectedCategory] = useState({ name: "all" });
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (selectedCategory.name === "all") {
      setFilteredProjects(projectsData);
    } else {
      const newProjects = projectsData.filter(
        (project) => project.category.toLowerCase() === selectedCategory.name
      );
      setFilteredProjects(newProjects);
    }
  }, [selectedCategory]);

  const handleClick = (e, index) => {
    setSelectedCategory({ name: e.target.textContent.toLowerCase() });
    setActiveIndex(index);
  };

  return (
    <div>
      {/* Filter Section */}
      <div className="work__filters">
        {projectsNav.map((item, index) => (
          <span
            onClick={(e) => handleClick(e, index)}
            className={`${activeIndex === index ? "active-work " : ""
              }work__item`}
            key={index}
          >
            {item.name}
          </span>
        ))}
      </div>

      {/* Projects Section */}
      <div className="work__container container grid">
        {filteredProjects.map((project) => (
          <WorkItems item={project} key={project.id} />
        ))}
      </div>
    </div>
  );
};

export default Works;
